import axios from 'axios';
import authHeader from './auth-header';
//import http from "../http-common";

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/mmlm/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/mmlm/';

class UserService {
  getAll() {
    return axios.get(API_URL + `sorted`, { headers: authHeader() });
    //return http.get(`/sorted`, { headers: authHeader() });
  }

  getAllPageable(lastName, page, pageSize) {
    return axios.get(API_URL + `users?lastName=${lastName}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `users/${id}`, { headers: authHeader() });
    //return http.get(`/users/${id}`, { headers: authHeader() });
  }

  create(user) {
    return axios.post(API_URL + `users`, {
      staffNo: user.staffNo,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: user.password,
      userType: user.userType
    }, { headers: authHeader() });
    //return http.post(`/users`, { headers: authHeader() }, data);
  }

  update(id, user) {
    return axios.put(API_URL + `users/${id}`, {
      staffNo: user.staffNo,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: user.password,
      userType: user.userType
    }, { headers: authHeader() });
    //return http.put(`/users/${id}`, { headers: authHeader() }, data);
  }

  delete(id) {
    return axios.delete(API_URL + `users/${id}`, { headers: authHeader() });
    //return http.delete(`/users/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `users`, { headers: authHeader() });
    //return http.delete(`/users`, { headers: authHeader() });
  }

  getByLastName(lastName) {
    return axios.get(API_URL + `users?lastName=${lastName}`, { headers: authHeader() });
    //return http.get(`/users?lastName=${lastName}`, { headers: authHeader() });
  }

  changePassword(username, user) {
    return axios.put(API_URL + `users/changepassword/${username}`, {
      staffNo: user.staffNo,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: user.password,
      userType: user.userType
    }, { headers: authHeader() });
  }
}

export default new UserService();